<template>
  <div class="menue-left-top">
    <img class="menue-left-top-logo" src="@/assets/menuTopLogo.png" alt="" srcset="">
    <div class="menue-left-top-search">
      <a-input class="font12R" v-model="searchMenu" placeholder="请输入" allow-clear @change="onChange" >
        <a-icon slot="prefix" type="search" style="font-size: 12px;color: #527ACC;"/>

      </a-input>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      searchMenu: ''
    }
  },
  methods: {
    onChange() {
      this.$emit('searchChange', this.searchMenu)
    }
  }

}
</script>

<style lang="less" scoped>

.menue-left-top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 20px 16px 16px;

  .menue-left-top-logo {
    width: 140px;
    height: auto;
    max-height: 42px;
    margin-bottom: 16px;
  }

  .menue-left-top-search {
    display: flex;
    align-items: center;
    width: 100%;
    height: 34px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 6px;
    overflow: hidden;
    transition: all 0.2s ease;

    &:hover,
    &:focus-within {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.16);
    }

    /deep/.ant-input {
      padding-top: 0;
      padding-bottom: 0;
      font-size: 13px;
      color: #e2e8f0;
      background: transparent !important;

      &::placeholder {
        color: #64748b;
      }
    }

    /deep/.anticon-search {
      color: #64748b !important;
    }
  }
}
</style>
